import type {ReactElement, ReactNode} from 'react';
import type {PrimitiveType} from 'src/public/formatMessage/types';
import type {
  FormatXMLElementFn,
  MessageDescriptor,
  MessageDescriptorBase,
} from 'src/public/message/types';

/**
 * @see https://sail.stripe.me/apis/intl/message
 */
export default function message<
  /** Generic type for the values to be passed-in to the message */
  TValues extends Record<
    string,
    PrimitiveType | ReactElement | ReactNode | FormatXMLElementFn
  > = never,
>(
  /** The [message descriptor](https://go/sail/intl/guides/localized-messages#message-descriptor). */
  descriptor: MessageDescriptorBase,
): MessageDescriptor<TValues> {
  return descriptor as MessageDescriptor<TValues>;
}
